import { UploadedDocument } from './uploaded-document.model';
import { FileUploadResult } from '../../shared/services/file/file.service';

export enum TemporaryFileSaveStatus {
  SAVED = 'SAVED',
  NOT_SAVED = 'NOT_SAVED',
  SAVING = 'SAVING',
}

export interface TemporaryFile extends UploadedDocument {
  uploadStatus: FileUploadResult;
  savedStatus: TemporaryFileSaveStatus;
  file?: File;
  fileFromUrl?: FileFromUrl;
  flashExtractionRequested?: boolean;
}

export interface FileFromUrl {
  url: string;
  name: string;
  size?: number;
}
